<template>
  <template v-if="mode == 'default'">
    <session class="page-container">
      <PageLeftNavs />
      <session class="page-main-container">
        <PageHeader />
        <router-view />
      </session>
    </session>
    <PageLogin />
    <Exchange />
    <cookie-banner />
  </template>
  <template v-if="mode == 'raw'">
    <router-view />
    <PageLogin />
  </template>

  <template v-if="mode == 'mobile'">
    <div class="page-mobile-container">
      <router-view />
      <BackToTop />
    </div>
    <mobile-cookie-banner />
  </template>
</template>

<script setup>
  import PageHeader from '@/components/header/index.vue';
  import PageLeftNavs from '@/components/leftnavs/index.vue';
  import PageFooter from '@/components/footer/index.vue';
  import BackToTop from '@/mobile/components/backtotop/index.vue';
  import PageLogin from '@/components/login/index.vue';
  import Exchange from '@/components/exchange/index.vue';
  import { ref, onMounted } from 'vue';
  import * as Utils from '@/assets/utils';

  const mode = ref('')

  let updateHeightTimer = null;
  const updateHeight = () => {
    clearTimeout(updateHeightTimer)
    updateHeightTimer = null;
    
    const app = document.getElementById('app');
    if(!app) {
      setTimeout(() => {
        updateHeight()
      }, 500);
      return;
    }
    app.style.height = 'auto'
  }

  const init = () => {
    const { pathname } = window.location;
    const pathnames = pathname.split('/') || [];
    const pathnameStr = pathnames[1] || '';
    
    // if([ 'protocol' ].includes(pathnameStr)) {
    //   mode.value = 'raw';
    // }else{
    //   mode.value = 'default';
    // }
    mode.value = 'default';

    if(Utils.isMobile()) {
      mode.value = 'mobile';

      updateHeight()
    }
  }
  onMounted(() => {
    init()
  })
</script>

<style lang="less">
  *{
    margin: 0;
    padding: 0;
  }
  html, body{
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    font-size: 14px;
    color: #333333;
    background-color: #FBF6F3;
  }
  #app {
    height: 100vh;
    // overflow-x: hidden;
  }
  .container{
    width: 1200px;
    margin: 0 auto;
  }
  .page-container{
    display: flex;
    height: 100%;
    overflow: hidden;
  }
  .page-mobile-container{
    width: 100%;
  }
  .ffen{
    font-family: Lexend Deca;
  }
  @media (max-width: 374px) {
    .page-mobile-container{
      min-width: 375px;
      overflow-x: auto;
    }
  }
  @media (min-width: 768px) and (max-width: 1440px) {
    .page-container{
      min-width: 1440px;
      overflow-x: auto;
    }
  }
  .page-main-container{
    flex: 1;
    display: flex;
    flex-direction: column;
    overflow: hidden;
  }

  @import '@/assets/fonts/index.less';

  // // slide
  // .slide-enter-active,
  // .slide-leave-active {
  //   transition: all 0.75s ease-out;
  // }
  // .slide-enter-to {
  //   position: absolute!important;
  //   right: 0;
  //   top: 84px;
  // }

  // .slide-enter-from {
  //   position: absolute!important;
  //   right: -100%;
  //   top: 84px;
  // }
  // .slide-leave-to {
  //   position: absolute!important;
  //   left: -100%;
  //   top: 84px;
  // }

  // .slide-leave-from {
  //   position: absolute!important;
  //   left: 0;
  //   top: 84px;
  // }
</style>
